import { Locale } from "../i18n/translatable.js";
/**
 * Return one of the available Dictionary Locales matching the given
 * locale as best as possible. When no locale is given, the language
 * codes given by the navigator will be used. When the navigator is
 * unavailable the JS default of 'en-US' will be used.
 *
 * @param locale
 * @returns
 */
export const getDictionaryLocale = (locale) => {
    let locales;
    if (locale) {
        if (locale.toUpperCase) {
            locales = [locale];
        }
        else if (locale.push) {
            locales = locale;
        }
        else {
            locales = [locale];
        }
    }
    else if (navigator) {
        locales = navigator.languages;
    }
    else {
        locales = ["en-US"];
    }
    const localeParser = new RegExp(/^([a-z][a-z]+)([-_]([A-Z][A-Z]))*$/, "gm");
    const availableLanguages = Object.values(Locale);
    //try for direct match first (i.e. lang-REGION)
    let foundLocales = locales.filter((locale) => availableLanguages.includes(locale));
    if (foundLocales.length > 0) {
        return foundLocales[0];
    }
    else {
        //try language codes only
        foundLocales = locales
            .map((locale) => {
            localeParser.lastIndex = 0;
            const matches = localeParser.exec(locale);
            return matches ? matches[1] : undefined;
        })
            .filter((locale) => locale && availableLanguages.includes(locale));
        if (foundLocales.length > 0) {
            return foundLocales[0];
        }
        else {
            //last resort....English
            return Locale.en;
        }
    }
};
//replacement for svelte import. Needed for making bundles for old tlmd implementation
const _browser = typeof window !== "undefined";
export const getLocale = (locale) => {
    return locale && locale !== "undefined"
        ? locale
        : _browser
            ? navigator.language
            : "en-US";
};
